'use client'
import { useRouter } from 'next/navigation'

import { EdsnText } from '@8percent/edsn-react'
import { EdsnIcon } from '@8percent/edsn-icons/react'

type Props = {
  title: string
}

export default function LogoHeader(props: Props) {
  const router = useRouter()

  const back = () => {
    router.back()
  }

  return (
    <div className="h-[56px] flex items-center">
      <div className="w-[48px] flex items-center justify-center cursor-pointer" onClick={back}>
        <EdsnIcon name="arrow-bold-left" size={18} />
      </div>
      <div className="w-full text-center overflow-hidden text-ellipsis whitespace-nowrap">
        <EdsnText variant="body-l-regular" as="span">
          {props.title}
        </EdsnText>
      </div>
      <div className="w-[48px] flex items-center justify-center"></div>
    </div>
  )
}
